/**
 * 使用此方法设置主题
 *
 * 新增主题需先在此处引入新主题的.scss文件，再在themeConfig里配置主题相关组件颜色
 */

// 先加载所有的主题(default在main.scss中加载，因为default主题对body没有使用class，可以应用在登陆页上)
import './styles.scss';

// 默认主题
export const defaultTheme = 'default';
export const whiteTheme = 'white';
export const themeList = [
  { color: '#16252E', name: '默认', key: 'default' },
  { color: '#287ACD', name: '白色', key: 'white' },
];

export const setTheme = (themeName = defaultTheme) => {
  // const key = 'themeProperty';
  // if (themeName === 'default') {
  //   // 移除之前主题的属性
  //   // window.localStorage.removeItem(key);
  //   if (document.body.className) document.body.className = '';
  // } else {
  // 把该主题的所有属性存到缓存
  //
  // }

  // 为了让scss能识别到主题使用的是哪个
  window.document.documentElement.setAttribute('data-theme', themeName);
  document.body.className = themeName;
  import(`./${themeName}/theme/index.css`);
};
